'use client';

import { jsx } from "react/jsx-runtime";
import { ArrowSquareOut } from "../../../../react-icons.js";
import { defaultProps } from "../Button.defaultProps.js";
import { getIconColor } from "./getIconColor.js";
import { getIconSize } from "./getIconSize.js";
import { getTextColor } from "./getTextColor.js";
import { getEmphasis } from "./getEmphasis.js";
function processCommonProps({
  emphasis: emphasisProp,
  icon: Icon,
  iconPosition: iconPositionProp,
  variant: variantProp,
  size: sizeProp,
  ...props
}) {
  const {
    children,
    a11yLabel,
    dataQa,
    disabled,
    iconStyle,
    hiddenLabel,
    onDark = false,
    fullWidth,
    pressed,
    target,
    ...propsToSpread
  } = props;
  const variant = variantProp || defaultProps.variant;
  const emphasis = getEmphasis({ emphasis: emphasisProp, variant });
  const size = sizeProp || defaultProps.size;
  const iconPosition = iconPositionProp || defaultProps.iconPosition;
  const isLabelHidden = hiddenLabel && !!Icon;
  const iconColor = getIconColor({ disabled, emphasis, onDark, variant });
  const iconSize = getIconSize({ size });
  const commonIconProps = {
    color: iconColor,
    size: iconSize
  };
  let iconJsx;
  if (Icon) {
    iconJsx = /* @__PURE__ */ jsx(Icon, { ...commonIconProps, filled: iconStyle === "filled" });
  } else if (target === "_blank") {
    iconJsx = /* @__PURE__ */ jsx(ArrowSquareOut, { ...commonIconProps });
  }
  return {
    ...props,
    dataQa,
    hasA11yLabel: Boolean(!isLabelHidden && a11yLabel && a11yLabel.length > 0),
    Icon,
    iconJsx,
    iconPosition,
    isLabelHidden,
    propsToSpread,
    size,
    spaceType: emphasis === "lowCompact" ? "compact" : "default",
    textColor: getTextColor({ disabled, onDark, emphasis, variant }),
    emphasis,
    variant,
    pressed,
    target
  };
}
export {
  processCommonProps
};
